export const LIBRARY_EXERCISE_COUNT_CACHE_KEY = 'trainer_library_exercise_total_count_v1';
export const LIBRARY_WORKOUTS_COUNT_CACHE_KEY = 'trainer_library_workouts_count_v1';
export const LIBRARY_WORKOUT_PLANS_COUNT_CACHE_KEY = 'trainer_library_workout_plans_count_v1';

const LIBRARY_COUNT_CACHE_MAX_AGE_MS = 24 * 60 * 60 * 1000;

export function readCachedLibraryCount(key: string): { count: number; loaded: boolean } {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return { count: 0, loaded: false };
    const parsed = JSON.parse(raw) as { count?: unknown; timestamp?: unknown };
    if (typeof parsed.count !== 'number' || !Number.isFinite(parsed.count) || parsed.count < 0) {
      return { count: 0, loaded: false };
    }
    if (
      typeof parsed.timestamp !== 'number'
      || Date.now() - parsed.timestamp > LIBRARY_COUNT_CACHE_MAX_AGE_MS
    ) {
      return { count: 0, loaded: false };
    }
    return { count: Math.round(parsed.count), loaded: true };
  } catch {
    return { count: 0, loaded: false };
  }
}

export function writeCachedLibraryCount(key: string, count: number): void {
  try {
    localStorage.setItem(key, JSON.stringify({ count, timestamp: Date.now() }));
  } catch {
    // Quota / disabled storage — fall through silently.
  }
}
